import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetBookingInfoAPI from "../../services/GetBookingInfo/GetBookingInfo";
import "./ratings-reviews.scss";
import Header from "../../components/header/header";
import HotelCard from "../../components/hotel-card/hotel-card";
import { pageUrl } from "../../utils/pageConstant";
import Loader from "../../components/loader/loader";
import { handleOutletName } from "../../utils";

const RatingsReviews = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(true);
  const [ratingDetails, setRatingDetails] = useState([]);

  const handleBack = () => {
    navigate(pageUrl.PROFILE);
  };

  const handleNext = (outlet) => {
    navigate(pageUrl.FEEDBACK, {
      state: { outletID: outlet?.outletId },
    });
  };

  useEffect(() => {
    getRatingDetails();
  }, []);

  const getRatingDetails = async () => {
    try {
      const responseData = await GetBookingInfoAPI();
      setRatingDetails(responseData);
      localStorage.setItem("outletDetailsInfo", JSON.stringify(responseData));
      setIsLoader(false);
    } catch (error) {}
  };

  return (
    <div className="paybill-page">
      {isLoader && <Loader />}
      <div className="top-section">
        <Header label="Ratings & Reviews" onClick={handleBack} />
      </div>
      <div className="hotel-section">
        {ratingDetails?.map((outlet) => {
          return (
            <>
              <HotelCard
                imgSrc={outlet?.outletMedias[0]?.mediaPath}
                name={handleOutletName(outlet?.outletName)}
                place={outlet?.address}
                offer={outlet?.localCouponDetails[0]}
                onClick={() => handleNext(outlet)}
              />
            </>
          );
        })}
      </div>
    </div>
  );
};

export default RatingsReviews;
